// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"TextButtonField_mainContainer__FGyNk","inputArea":"TextButtonField_inputArea__3UpZt","uploadButton":"TextButtonField_uploadButton__27RWY"};